<section *ngIf="text && text.length">
  <p>{{text}}</p>
</section>
